import { postJsMessage } from '../../bridge';
import API from '../../api';
import { isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * clipboard.read
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    6.1.0
 * linux      6.1.0
 * ios        6.4.5
 * android    6.1.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function read(): Promise<NativeAPIResponseMessage<ClipboardData>> {
  return isAvailable('clipboard.read').then(() => {
    return postJsMessage<any, ClipboardData>(API.clipboardRead, {});
  });
}

export type ClipboardData = {
  clipboardItems: ClipboardItem[];
  srcAppName?: string;
};

export type ClipboardItem = {
  mime: string;
  data: string;
};

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * clipboard.write
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.4.5
 * android    6.1.0
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function write(
  data: ClipboardData
): Promise<NativeAPIResponseMessage<any>> {
  return isAvailable('clipboard.write').then(() => {
    return postJsMessage(API.clipboardWrite, { ...data });
  });
}

export default {
  read,
  write,
};
